import React, { useEffect, useRef, useState } from "react";
import "./assets/index.scss";

const App = () => {
  const [mode, setMode] = useState<"light" | "dark">("light");
  const [isModeChanging, setIsModeChanging] = useState(false);

  const appRef = useRef<HTMLDivElement>(null);
  const sunRef = useRef<SVGGElement>(null);
  const layer1Ref = useRef<SVGGElement>(null);
  const layer2Ref = useRef<SVGGElement>(null);
  const layer3Ref = useRef<SVGGElement>(null);
  const skyRef = useRef<SVGGElement>(null);

  const changeMode = () => {
    setIsModeChanging(true);
    if (sunRef.current) {
      sunRef.current.classList.add("sun-rise");
    }

    if (mode === "light") {
      setMode("dark");

      if (appRef.current) {
        appRef.current.classList.add("dark");
      }
    } else {
      setMode("light");
      if (appRef.current) {
        appRef.current.classList.remove("dark");
      }
    }
    setTimeout(() => {
      if (sunRef.current && !isModeChanging) {
        sunRef.current.classList.remove("sun-rise");
        setIsModeChanging(false);
      }
    }, 2000);
  };

  useEffect(() => {
    if (appRef.current) {
      appRef.current.addEventListener("mousemove", (event) => {
        if (
          skyRef.current &&
          sunRef.current &&
          layer1Ref.current &&
          layer2Ref.current &&
          layer3Ref.current
        ) {
          skyRef.current.style.transform = `translateY(${event.y * -0.02}px)`;
          sunRef.current.style.transform = `translateY(${event.y * -0.02}px)`;
          layer1Ref.current.style.transform = `translate(${
            event.x * -0.05
          }px, ${event.y * -0.03}px)`;
          layer2Ref.current.style.transform = `translate(${
            event.x * -0.06
          }px, ${event.y * -0.04}px)`;
          layer3Ref.current.style.transform = `translate(${
            event.x * -0.01
          }px, ${event.y * -0.01}px)`;
        }
      });
    }
  }, []);

  return (
    <div ref={appRef} className="App">
      <svg
        className="svg"
        version="1.1"
        x="0px"
        y="0px"
        viewBox="0 0 1920 1080"
      >
        <g ref={sunRef} id="sun">
          <circle cx="386.1" cy="205.85" r="168.47" />
        </g>

        <g id="Layer1" ref={layer1Ref}>
          <g id="mountains3">
            <path
              d="M-107.57,434.57c12.81-19.2,113.93-135.12,149.11-140.53c16.29-2.5,38.97-0.55,117.96,53.62
							c87.51,60.01,82.49,73.28,124.09,87.32c22.73,7.68,71.43,19.65,128.68,13.79c35.58-3.64,49.14-11.58,72-3.06
							c34.41,12.82,31.53,41.18,65.87,62.81c34.01,21.41,81.11,21.49,114.89,7.66c42.88-17.55,35.17-45.58,88.85-73.53
							c15.84-8.25,57.13-29.75,94.98-15.32c20.4,7.78,20.61,18.68,41.36,29.11c42.56,21.38,92.9,1.24,99.57-1.53
							c41.03-17.06,43.79-44.6,107.23-130.21c45.81-61.82,69.4-92.95,102.64-104.17c44.9-15.15,100.98-4.04,136.34,26.04
							c29.85,25.39,26.46,48.56,61.28,102.64c39.35,61.1,52.13,75.4,70.47,82.72c25.81,10.31,50.54,5.61,72,1.53
							c47.15-8.96,55.61-40.36,88.85-41.36c23.15-0.7,48.2,12.56,62.81,30.64c17.2,21.29,11.38,39.76,26.04,47.49
							c22.79,12.02,60.99-19.9,62.81-21.45c35.21-30.01,22.96-55.25,62.81-113.36c29.76-43.4,52.91-53.12,64.34-56.68
							c17.2-5.36,129.78-11.16,139.91-9.7l73.53,866.7l-2299.91-11.38L-107.57,434.57z"
            />
          </g>
        </g>

        <g id="Layer2" ref={layer2Ref}>
          <g id="mountains2">
            <g>
              <path
                d="M-154.55,747.96c28.54-11.23,204.97-48.21,254.3-40.3c45.52,7.3,70.85,27.47,125.62,58.21
								c82.84,46.49,124.25,69.74,162.38,75.06c90.65,12.66,206.19-31.78,272.68-84.26c13.46-10.62,29.91-25.52,55.15-27.57
								c44.26-3.6,57.42,37.05,113.36,45.96c38.75,6.17,41.45-11.89,94.98-7.66c50.9,4.02,54.98,20.88,84.26,15.32
								c40.17-7.62,43.59-41.46,90.38-64.34c33.18-16.23,48.55-7.57,96.51-13.79c95.61-12.4,107.25-56.24,176.17-64.34
								c32.2-3.79,40.26,4.54,176.17,58.21c172.45,68.1,210.93,75.02,235.91,78.13c63.44,7.89,240.21,2.59,294.64-11.23l30.64,385.02
								H-150.47L-154.55,747.96z"
              />
            </g>
          </g>
        </g>

        <g id="Sky" ref={skyRef}>
          <g className="cloud" id="cloud1">
            <path
              d="M-401.36,188.59c0,0,14.59-2.3,25.73,4.99c11.14,7.3,42.25,11.91,54.16,6.91
              c11.91-4.99,14.59-18.82,12.29-24.58c-2.3-5.76-13.83-10.75-18.82-7.3c-4.99,3.46-2.69-7.3,8.07-6.53s15.36,8.2,17.67,20.23
              c2.3,12.03,10.37,26.63,26.89,30.47c16.52,3.84,39.18,2.69,42.25-13.06c3.07-15.75-2.69-19.59-8.83-23.43
              c-6.15-3.84-16.52,1.92-16.52,1.92s9.22,3.73,8.83,10.12c-0.38,6.39-9.99,10.89-12.67,0c-2.69-10.89,1.15-18.19,9.99-21.26
              c8.83-3.07,17.28-1.92,23.81,13.83s16.9,34.57,33.41,36.49s25.35-15.36,34.57-10.75c9.22,4.61,4.61,6.53,15.75,9.22
              c11.14,2.69,7.68-4.61,16.13-4.61c8.45,0,21.89-3.46,29.19-11.14s11.14-34.18,0-40.71s-25.35-9.22-30.73,3.07
              c-5.38,12.29,4.61,23.24,4.61,23.24s-14.98-3.65-14.21-18.25s13.06-23.43,25.35-23.81s21.89,9.22,26.5,19.59
              c4.61,10.37,4.99,21.89,11.14,30.73c6.15,8.83,23.96-1.45,29.57-5.12c6.66-4.35,12.55-16.9,23.43-21.38
              c10.4-4.28,23.81-0.77,23.81-0.77s-8.45-8.83-16.9-9.22s-14.98,4.61-21.51,10.75s-19.2,13.83-38.02-14.21s-24.2-36.1-53.77-38.02
              s-26.89,8.45-27.27,19.59c-0.38,11.14,1.15,21.89-6.53,23.43s-16.52,6.91-19.97-0.77s2.69-9.99,5.76-6.91
              c3.07,3.07,5.76,6.91,8.07,2.69c2.3-4.22,10.61-23.76,5.89-33.85c-4.95-10.58-6.27-14.16-24.32-16.85
              c-18.05-2.69-34.95,4.22-42.25,16.52s-3.84,14.59-3.84,14.59s-13.06-5.38-12.67-12.29s-16.52-6.15-21.12-0.77
              c-4.61,5.38-7.3,23.43-6.91,23.43c0.38,0-16.9-1.54-18.82,1.15s-6.91,9.99-7.3,1.15c-0.38-8.83-8.83-11.91-21.51-9.22
              c-12.67,2.69-11.14,8.07-12.29,11.91c-1.15,3.84-13.06-2.3-21.51,6.15c-8.45,8.45-15.36,23.43-8.45,28.42
              c6.91,4.99,18.44,4.05,20.55-0.47c2.11-4.52,7.63,4.9-2.5,8.54C-364.02,198.47-395.22,178.6-401.36,188.59z"
            />
          </g>

          <g className="cloud" id="cloud2">
            <path
              d="M-320,415.32c0,0,9.7-1.53,17.11,3.32c7.4,4.85,28.09,7.91,36,4.6c7.91-3.32,9.7-12.51,8.17-16.34
              c-1.53-3.83-9.19-7.15-12.51-4.85c-3.32,2.3-1.79-4.85,5.36-4.34c7.15,0.51,10.21,5.45,11.74,13.45c1.53,8,6.89,17.7,17.87,20.25
              c10.98,2.55,26.04,1.79,28.09-8.68c2.04-10.47-1.79-13.02-5.87-15.57c-4.09-2.55-10.98,1.28-10.98,1.28s6.13,2.48,5.87,6.73
              c-0.26,4.25-6.64,7.24-8.43,0s0.77-12.09,6.64-14.13c5.87-2.04,11.49-1.28,15.83,9.19c4.34,10.47,11.23,22.98,22.21,24.26
              c10.98,1.28,16.85-10.21,22.98-7.15c6.13,3.06,3.06,4.34,10.47,6.13c7.4,1.79,5.11-3.06,10.72-3.06s14.55-2.3,19.4-7.4
              c4.85-5.11,7.4-22.72,0-27.06c-7.4-4.34-16.85-6.13-20.43,2.04c-3.57,8.17,3.06,15.45,3.06,15.45s-9.96-2.43-9.45-12.13
              c0.51-9.7,8.68-15.57,16.85-15.83s14.55,6.13,17.62,13.02s3.32,14.55,7.4,20.43c4.09,5.87,15.93-0.96,19.66-3.4
              c4.43-2.89,8.34-11.23,15.57-14.21c6.91-2.85,15.83-0.51,15.83-0.51s-5.62-5.87-11.23-6.13c-5.62-0.26-9.96,3.06-14.3,7.15
              c-4.34,4.09-12.77,9.19-25.28-9.45s-16.09-24-35.74-25.28c-19.66-1.28-17.87,5.62-18.13,13.02c-0.26,7.4,0.77,14.55-4.34,15.57
              c-5.11,1.02-10.98,4.6-13.28-0.51c-2.3-5.11,1.79-6.64,3.83-4.6c2.04,2.04,3.83,4.6,5.36,1.79s6.89-14.3,4.09-22.34
              c-2.56-7.33-4.34-9.57-16.34-11.36s-23.23,2.81-28.09,10.98c-4.85,8.17-2.55,9.7-2.55,9.7s-8.68-3.57-8.43-8.17
              c0.26-4.6-10.98-4.09-14.04-0.51c-3.06,3.57-4.85,15.57-4.6,15.57c0.26,0-11.23-1.02-12.51,0.77s-4.6,6.64-4.85,0.77
              c-0.26-5.87-5.87-7.91-14.3-6.13c-8.43,1.79-7.4,5.36-8.17,7.91s-8.68-1.53-14.3,4.09c-5.62,5.62-10.21,15.57-5.62,18.89
              c4.6,3.32,12.26,2.69,13.66-0.31c1.4-3.01,5.07,3.25-1.66,5.68C-295.18,421.89-315.91,408.68-320,415.32z"
            />
          </g>

          <g className="cloud" id="cloud3">
            <path
              d="M-556.83,289.81c0,0,19.4-3.06,34.21,6.64c14.81,9.7,56.17,15.83,72,9.19c15.83-6.64,19.4-25.02,16.34-32.68
            c-3.06-7.66-18.38-14.3-25.02-9.7c-6.64,4.6-3.57-9.7,10.72-8.68s20.43,10.9,23.49,26.9c3.06,16,13.79,35.4,35.74,40.51
            c21.96,5.11,52.09,3.57,56.17-17.36c4.09-20.94-3.57-26.04-11.74-31.15s-21.96,2.55-21.96,2.55s12.26,4.96,11.74,13.46
            c-0.51,8.5-13.28,14.48-16.85,0c-3.57-14.48,1.53-24.18,13.28-28.27c11.74-4.09,22.98-2.55,31.66,18.38
            c8.68,20.94,22.47,45.96,44.43,48.51c21.96,2.55,33.7-20.43,45.96-14.3c12.26,6.13,6.13,8.68,20.94,12.26
            c14.81,3.57,10.21-6.13,21.45-6.13c11.23,0,29.11-4.6,38.81-14.81c9.7-10.21,14.81-45.45,0-54.13
            c-14.81-8.68-33.7-12.26-40.85,4.09c-7.15,16.34,6.13,30.9,6.13,30.9s-19.91-4.85-18.89-24.26s17.36-31.15,33.7-31.66
            s29.11,12.26,35.23,26.04c6.13,13.79,6.64,29.11,14.81,40.85s31.86-1.93,39.32-6.81c8.85-5.79,16.68-22.47,31.15-28.43
            c13.82-5.69,31.66-1.02,31.66-1.02s-11.23-11.74-22.47-12.26s-19.91,6.13-28.6,14.3c-8.68,8.17-25.53,18.38-50.55-18.89
            s-32.17-48-71.49-50.55s-35.74,11.23-36.26,26.04c-0.51,14.81,1.53,29.11-8.68,31.15c-10.21,2.04-21.96,9.19-26.55-1.02
            c-4.6-10.21,3.57-13.28,7.66-9.19c4.09,4.09,7.66,9.19,10.72,3.57s11.52-30.59,7.55-44.27c-4.33-14.91-8.06-19.56-32.06-23.13
            c-24-3.57-46.47,5.62-56.17,21.96c-9.7,16.34-5.11,19.4-5.11,19.4s-17.36-7.15-16.85-16.34c0.51-9.19-21.96-8.17-28.09-1.02
            c-6.13,7.15-9.7,31.15-9.19,31.15c0.51,0-20.54-0.44-25.02,1.53c-4.02,1.77-9.19,13.28-9.7,1.53
            c-0.51-11.74-11.74-15.83-28.6-12.26c-16.85,3.57-14.81,10.72-16.34,15.83s-17.36-3.06-28.6,8.17s-20.43,31.15-11.23,37.79
            c9.19,6.64,24.51,5.38,27.32-0.63c2.81-6.01,10.14,6.51-3.32,11.35C-507.18,302.95-548.66,276.53-556.83,289.81z"
            />
          </g>

          <g className="cloud" id="cloud4">
            <path
              d="M-401.36,188.59c0,0,14.59-2.3,25.73,4.99c11.14,7.3,42.25,11.91,54.16,6.91
              c11.91-4.99,14.59-18.82,12.29-24.58c-2.3-5.76-13.83-10.75-18.82-7.3c-4.99,3.46-2.69-7.3,8.07-6.53s15.36,8.2,17.67,20.23
              c2.3,12.03,10.37,26.63,26.89,30.47c16.52,3.84,39.18,2.69,42.25-13.06c3.07-15.75-2.69-19.59-8.83-23.43
              c-6.15-3.84-16.52,1.92-16.52,1.92s9.22,3.73,8.83,10.12c-0.38,6.39-9.99,10.89-12.67,0c-2.69-10.89,1.15-18.19,9.99-21.26
              c8.83-3.07,17.28-1.92,23.81,13.83s16.9,34.57,33.41,36.49s25.35-15.36,34.57-10.75c9.22,4.61,4.61,6.53,15.75,9.22
              c11.14,2.69,7.68-4.61,16.13-4.61c8.45,0,21.89-3.46,29.19-11.14s11.14-34.18,0-40.71s-25.35-9.22-30.73,3.07
              c-5.38,12.29,4.61,23.24,4.61,23.24s-14.98-3.65-14.21-18.25s13.06-23.43,25.35-23.81s21.89,9.22,26.5,19.59
              c4.61,10.37,4.99,21.89,11.14,30.73c6.15,8.83,23.96-1.45,29.57-5.12c6.66-4.35,12.55-16.9,23.43-21.38
              c10.4-4.28,23.81-0.77,23.81-0.77s-8.45-8.83-16.9-9.22s-14.98,4.61-21.51,10.75s-19.2,13.83-38.02-14.21s-24.2-36.1-53.77-38.02
              s-26.89,8.45-27.27,19.59c-0.38,11.14,1.15,21.89-6.53,23.43s-16.52,6.91-19.97-0.77s2.69-9.99,5.76-6.91
              c3.07,3.07,5.76,6.91,8.07,2.69c2.3-4.22,10.61-23.76,5.89-33.85c-4.95-10.58-6.27-14.16-24.32-16.85
              c-18.05-2.69-34.95,4.22-42.25,16.52s-3.84,14.59-3.84,14.59s-13.06-5.38-12.67-12.29s-16.52-6.15-21.12-0.77
              c-4.61,5.38-7.3,23.43-6.91,23.43c0.38,0-16.9-1.54-18.82,1.15s-6.91,9.99-7.3,1.15c-0.38-8.83-8.83-11.91-21.51-9.22
              c-12.67,2.69-11.14,8.07-12.29,11.91c-1.15,3.84-13.06-2.3-21.51,6.15c-8.45,8.45-15.36,23.43-8.45,28.42
              c6.91,4.99,18.44,4.05,20.55-0.47c2.11-4.52,7.63,4.9-2.5,8.54C-364.02,198.47-395.22,178.6-401.36,188.59z"
            />
          </g>

          <g className="cloud" id="cloud5">
            <path
              d="M-320,415.32c0,0,9.7-1.53,17.11,3.32c7.4,4.85,28.09,7.91,36,4.6c7.91-3.32,9.7-12.51,8.17-16.34
              c-1.53-3.83-9.19-7.15-12.51-4.85c-3.32,2.3-1.79-4.85,5.36-4.34c7.15,0.51,10.21,5.45,11.74,13.45c1.53,8,6.89,17.7,17.87,20.25
              c10.98,2.55,26.04,1.79,28.09-8.68c2.04-10.47-1.79-13.02-5.87-15.57c-4.09-2.55-10.98,1.28-10.98,1.28s6.13,2.48,5.87,6.73
              c-0.26,4.25-6.64,7.24-8.43,0s0.77-12.09,6.64-14.13c5.87-2.04,11.49-1.28,15.83,9.19c4.34,10.47,11.23,22.98,22.21,24.26
              c10.98,1.28,16.85-10.21,22.98-7.15c6.13,3.06,3.06,4.34,10.47,6.13c7.4,1.79,5.11-3.06,10.72-3.06s14.55-2.3,19.4-7.4
              c4.85-5.11,7.4-22.72,0-27.06c-7.4-4.34-16.85-6.13-20.43,2.04c-3.57,8.17,3.06,15.45,3.06,15.45s-9.96-2.43-9.45-12.13
              c0.51-9.7,8.68-15.57,16.85-15.83s14.55,6.13,17.62,13.02s3.32,14.55,7.4,20.43c4.09,5.87,15.93-0.96,19.66-3.4
              c4.43-2.89,8.34-11.23,15.57-14.21c6.91-2.85,15.83-0.51,15.83-0.51s-5.62-5.87-11.23-6.13c-5.62-0.26-9.96,3.06-14.3,7.15
              c-4.34,4.09-12.77,9.19-25.28-9.45s-16.09-24-35.74-25.28c-19.66-1.28-17.87,5.62-18.13,13.02c-0.26,7.4,0.77,14.55-4.34,15.57
              c-5.11,1.02-10.98,4.6-13.28-0.51c-2.3-5.11,1.79-6.64,3.83-4.6c2.04,2.04,3.83,4.6,5.36,1.79s6.89-14.3,4.09-22.34
              c-2.56-7.33-4.34-9.57-16.34-11.36s-23.23,2.81-28.09,10.98c-4.85,8.17-2.55,9.7-2.55,9.7s-8.68-3.57-8.43-8.17
              c0.26-4.6-10.98-4.09-14.04-0.51c-3.06,3.57-4.85,15.57-4.6,15.57c0.26,0-11.23-1.02-12.51,0.77s-4.6,6.64-4.85,0.77
              c-0.26-5.87-5.87-7.91-14.3-6.13c-8.43,1.79-7.4,5.36-8.17,7.91s-8.68-1.53-14.3,4.09c-5.62,5.62-10.21,15.57-5.62,18.89
              c4.6,3.32,12.26,2.69,13.66-0.31c1.4-3.01,5.07,3.25-1.66,5.68C-295.18,421.89-315.91,408.68-320,415.32z"
            />
          </g>

          <g className="cloud" id="cloud6">
            <path
              d="M-556.83,289.81c0,0,19.4-3.06,34.21,6.64c14.81,9.7,56.17,15.83,72,9.19c15.83-6.64,19.4-25.02,16.34-32.68
            c-3.06-7.66-18.38-14.3-25.02-9.7c-6.64,4.6-3.57-9.7,10.72-8.68s20.43,10.9,23.49,26.9c3.06,16,13.79,35.4,35.74,40.51
            c21.96,5.11,52.09,3.57,56.17-17.36c4.09-20.94-3.57-26.04-11.74-31.15s-21.96,2.55-21.96,2.55s12.26,4.96,11.74,13.46
            c-0.51,8.5-13.28,14.48-16.85,0c-3.57-14.48,1.53-24.18,13.28-28.27c11.74-4.09,22.98-2.55,31.66,18.38
            c8.68,20.94,22.47,45.96,44.43,48.51c21.96,2.55,33.7-20.43,45.96-14.3c12.26,6.13,6.13,8.68,20.94,12.26
            c14.81,3.57,10.21-6.13,21.45-6.13c11.23,0,29.11-4.6,38.81-14.81c9.7-10.21,14.81-45.45,0-54.13
            c-14.81-8.68-33.7-12.26-40.85,4.09c-7.15,16.34,6.13,30.9,6.13,30.9s-19.91-4.85-18.89-24.26s17.36-31.15,33.7-31.66
            s29.11,12.26,35.23,26.04c6.13,13.79,6.64,29.11,14.81,40.85s31.86-1.93,39.32-6.81c8.85-5.79,16.68-22.47,31.15-28.43
            c13.82-5.69,31.66-1.02,31.66-1.02s-11.23-11.74-22.47-12.26s-19.91,6.13-28.6,14.3c-8.68,8.17-25.53,18.38-50.55-18.89
            s-32.17-48-71.49-50.55s-35.74,11.23-36.26,26.04c-0.51,14.81,1.53,29.11-8.68,31.15c-10.21,2.04-21.96,9.19-26.55-1.02
            c-4.6-10.21,3.57-13.28,7.66-9.19c4.09,4.09,7.66,9.19,10.72,3.57s11.52-30.59,7.55-44.27c-4.33-14.91-8.06-19.56-32.06-23.13
            c-24-3.57-46.47,5.62-56.17,21.96c-9.7,16.34-5.11,19.4-5.11,19.4s-17.36-7.15-16.85-16.34c0.51-9.19-21.96-8.17-28.09-1.02
            c-6.13,7.15-9.7,31.15-9.19,31.15c0.51,0-20.54-0.44-25.02,1.53c-4.02,1.77-9.19,13.28-9.7,1.53
            c-0.51-11.74-11.74-15.83-28.6-12.26c-16.85,3.57-14.81,10.72-16.34,15.83s-17.36-3.06-28.6,8.17s-20.43,31.15-11.23,37.79
            c9.19,6.64,24.51,5.38,27.32-0.63c2.81-6.01,10.14,6.51-3.32,11.35C-507.18,302.95-548.66,276.53-556.83,289.81z"
            />
          </g>
        </g>

        <g id="Layer3" ref={layer3Ref}>
          <g id="mountains1">
            <path
              d="M-93.28,949.19l-10.21,159.32l2150.81-10.21l-6.13-302.3c-15.27-5.59-145.08-61.42-173.62-73.02
              c-117.24-47.66-115.45-59.49-150.13-64.34c-25.54-3.57-25.27,3.02-200.68,67.4c-72.75,26.7-87.45,30.95-105.7,50.55
              c-38.97,41.87-37.06,92.52-68.94,99.57c-17.37,3.85-25.03-9.62-53.62-22.98c-76.24-35.62-163.9-6.2-196.09,4.6
              c-53.6,17.99-43.63,29.84-85.79,39.83c-72.39,17.15-138.51-9.1-168.51-21.45c-64.01-26.34-60.78-46.83-119.49-64.34
              c-61.05-18.21-72.35,1.61-116.19-18.03c-59.91-26.84-54.56-70.91-109.01-93.8c-43.92-18.46-98.06-11.08-136.34,9.19
              c-80.76,42.78-81.23,137.87-134.81,140.94c-35.46,2.03-50.48-38.75-87.32-30.64c-23.43,5.16-29.5,24.33-59.74,53.62
              c-17.68,17.12-45.36,39.38-87.32,58.21L-93.28,949.19z"
            />
          </g>

          <g id="arc">
            <polygon points="358.47,729.96 375.15,577.11 387.4,577.11 382.3,729.96 		" />
            <polygon points="493.28,577.11 500.09,733.02 521.87,733.02 507.57,577.11 		" />
            <path
              d="M308.77,548.17c0,0,27.23,14.3,64.17,15.66s139.06,0,139.06,0s48.34-8.51,60.94-15.66
			c12.6-7.15-21.79,30.64-21.79,30.64l-221.28,1.36C329.87,580.17,307.06,552.26,308.77,548.17z"
            />
            <polygon points="432,577.11 430.3,615.57 452.09,615.57 452.09,577.11 		" />
            <path
              d="M378.55,669.05c0,0,25.53-39.52,62.3-39.52s59.23,41.87,59.23,41.87v-20.94c0,0-26.89-30.81-59.23-30.81
			s-65.02,35.4-65.02,35.4L378.55,669.05z"
            />
            <polyline points="346.55,613.62 534.81,613.62 534.14,627.62 347.89,626.43 346.55,614.41 		" />
          </g>

          <g id="tree1">
            <path d="M369.71,510.84S313,493.07,305.79,454.37s-5.16-101.61-1.14-111.5,27.7-43.48,39.36-52.27,27.14-19.3,41.47-20.64S419.59,262.32,425,258s33-5.16,39.84-11.32,9.6-10,9.6-10-18.92,11-26.37,12-11.89-.86-11.89-.86a35.44,35.44,0,0,0,6.07-7.14c2.12-3.44,2.57-8.65,2.57-8.65s-.19,7.19-12.66,13.07-14.9,8.6-18.63,4.73-9.75-11.9-15.34-12-6.87-.86-6.87-.86,10.17,3.73,12.75,9.6,3.15,10.32-2.29,9.89-37-.43-53.8,8.36-47,37.84-47,37.84-3.44-22.36-29.63-37.45-49.49-23.32-50.64-31.92a134.92,134.92,0,0,1-.95-17.77S255.92,217,266,212.83s50.07-18.92,64.79-28.48,44.33-32.46,44.54-33.46,12.31-3.61,20.05-2.85,13.37-1.53,14.42-2.77a53.86,53.86,0,0,0,3.35-5.44s-5.16,3.91-9.27,4.49-21.31-.29-21.31-.29a18.94,18.94,0,0,0-1.33-8.31c-1.72-3.63-3.35-6.69-3.35-6.69s2.77,6.5.57,9.75-4.58,4.3-5.25,4.2-3.73,0-3.54-2.87a10.08,10.08,0,0,1,1.44-4.68,15,15,0,0,0-4.49,3.54c-2.49,2.67-1.05,11.75-3.92,13.76S326.62,178.24,302.16,183s-61.34,6.88-68.22,7.07-14.15.2-14.15.2-2.48-29.24-8.4-38.22-9.17-12-25.61-12.42-28.85,2.1-31.34-1.92-3.82-14-3.82-14,.58,8.22-2.1,11.47-3.44,3.63-13,3.25-11.66-.57-22.74-6.5-12.62-8.22-12.62-8.22,3.06,4.59,3.83,8.41-3.06,5.35-10.71,1.91-11.84-3.82-17-3.63a21.14,21.14,0,0,0-9.56,3.06s11.08-2.87,16.63,1.15,17.58,7.64,31.34,9.36,47.77,4,63.82,6.31S198.4,167,198.78,176.13s-2.49,50.07.38,62.3,14.14,23.7,19.49,29.24,13.95,10.51,13.95,10.51-10.7,11.08-32.67,10.32-34.4,2.87-47.11-2.39-17.29-13.28-17.29-13.28,1.14,6.78-.29,7.07-13-5.4-19.06-10a60.46,60.46,0,0,1-9.32-8.59s.72,7,5.16,10.6,11.9,7.88,7.88,8.74-28.09-1.72-33.1-9.31S79.49,261,79.49,261s.86,9.46,5.59,15.05,15.33,10,39.12,13,25.94,6.45,32.39,8.89,39.13,7.5,59.77,5.59,36.5-9.37,44.14.95,10.13,29.05,5.35,38.41-4.77,25.8-19.87,21.6-28.09-15.1-47-15.87-35.35,6.69-48.54,9.75-41.56,4.63-45.86.62-1.43-8.74,3.58-12,5.59-7.74,5.59-7.74a28.74,28.74,0,0,1-6.31,5.45c-4.29,2.87-8.45,6.59-10.67,7.88-1,.6-7.67,1-9.25-3.29s-3.72-9-3.72-9-3.3,5.59-1.15,9.46-2.72,4.72-6.74,2.72-13.32-8.31-17.48-8.74a15.71,15.71,0,0,0-7.17.86s9.75.57,15.77,7.59,14.9,10.18,28.66,12.33,51,3.15,67.22,2.43,32.53.58,42.57,7.46a73.45,73.45,0,0,1,16.19,15.33s-16.77,3.87-21.07,25.37,21.5,62.63,21.5,62.63,9.46,18.78,51.31,28.24S369.71,510.84,369.71,510.84Z" />
            <path d="M14.18,117.66s190.71.76,197.21,0,18,.76,14.14-14.52S212.92,72.94,198,71.41l-14.9-1.52s4.2-10.71-11.85-18.35S128.07,47,128.07,47s-2.29-8.79-23.69-11.08-43.95,6.5-50.45,17.58-4.21,23.3-4.21,23.3-22.93-6.86-39,10.33S1.57,118,1.57,118Z" />
            <path d="M40.67,256.7s120.68.49,124.79,0,11.36.49,8.95-9.19-8-19.1-17.42-20.07l-9.43-1s2.66-6.77-7.5-11.6S112.74,212,112.74,212s-1.45-5.56-15-7-27.81,4.11-31.92,11.13a23.51,23.51,0,0,0-2.66,14.74s-14.51-4.35-24.67,6.54-5.8,19.56-5.8,19.56Z" />
            <path d="M28.86,331.47s94,.38,97.18,0,8.86.38,7-7.16-6.21-14.88-13.56-15.63l-7.34-.75s2.07-5.28-5.84-9S85,296.63,85,296.63s-1.13-4.34-11.67-5.47-21.66,3.21-24.87,8.67a18.31,18.31,0,0,0-2.07,11.48s-11.3-3.38-19.21,5.09-4.52,15.24-4.52,15.24Z" />
            <path d="M439.38,126.49s-94,.38-97.19,0-8.85.38-7-7.16,6.22-14.88,13.56-15.63l7.35-.75s-2.07-5.28,5.84-9,21.28-2.26,21.28-2.26,1.13-4.34,11.68-5.47,21.66,3.21,24.86,8.67a18.31,18.31,0,0,1,2.07,11.48s11.3-3.38,19.21,5.09,4.52,15.24,4.52,15.24Z" />
            <path d="M502.54,224.82s-128.09.51-132.45,0-12.07.51-9.5-9.76,8.47-20.28,18.48-21.3l10-1s-2.82-7.19,8-12.32,29-3.08,29-3.08,1.54-5.91,15.91-7.45,29.52,4.37,33.89,11.81a25,25,0,0,1,2.82,15.65s15.4-4.61,26.18,6.94S511,225.05,511,225.05Z" />
          </g>

          <g id="tree2">
            <path
              d="M206.78,511.79c0,0,33.97-10.64,38.26-33.8s3.09-60.82,0.69-66.74c-2.4-5.92-16.58-26.02-23.56-31.28
              c-6.98-5.26-16.24-11.55-24.82-12.35s-20.42-4.57-23.68-7.15s-19.73-3.09-23.85-6.78c-4.12-3.69-5.75-6-5.75-6
              s11.32,6.61,15.78,7.21c4.46,0.6,7.12-0.51,7.12-0.51s-2.15-1.87-3.64-4.28c-1.27-2.06-1.54-5.17-1.54-5.17s0.11,4.31,7.57,7.82
              c7.46,3.52,8.92,5.15,11.15,2.83s5.83-7.12,9.18-7.21s4.12-0.51,4.12-0.51s-6.09,2.23-7.63,5.75s-1.89,6.18,1.37,5.92
              c3.26-0.26,22.13-0.26,32.2,5s28.13,22.65,28.13,22.65s2.06-13.38,17.73-22.42c15.67-9.04,29.62-13.95,30.31-19.1
              c0.69-5.15,0.57-10.64,0.57-10.64s-21.62,0.91-27.68-1.6s-29.97-11.32-38.77-17.04c-8.81-5.72-26.53-19.43-26.66-20.03
              c-0.13-0.6-7.36-2.16-11.99-1.7s-8.01-0.92-8.64-1.66c-0.63-0.74-2-3.26-2-3.26s3.09,2.34,5.55,2.69
              c2.46,0.34,12.75-0.17,12.75-0.17s-0.23-2.8,0.8-4.98s2-4,2-4s-1.66,3.89-0.34,5.83c1.32,1.94,2.74,2.57,3.15,2.52s2.23,0,2.12-1.72
              c-0.11-1.72-0.86-2.8-0.86-2.8s1.2,0.51,2.69,2.12c1.49,1.6,0.63,7.03,2.34,8.23c1.72,1.2,21.62,15.27,36.26,18.13
              c14.64,2.86,36.71,4.12,40.83,4.23c4.12,0.11,8.47,0.11,8.47,0.11s1.48-17.5,5.03-22.87c3.55-5.38,5.49-7.21,15.33-7.43
              c9.84-0.23,17.27,1.26,18.76-1.14c1.49-2.4,2.29-8.35,2.29-8.35s-0.34,4.92,1.26,6.86c1.6,1.94,2.06,2.17,7.78,1.94
              c5.72-0.23,6.98-0.34,13.61-3.89c6.63-3.55,7.55-4.92,7.55-4.92s-1.83,2.74-2.29,5.03c-0.46,2.29,1.83,3.2,6.4,1.14
              c4.57-2.06,7.09-2.29,10.18-2.17s5.72,1.83,5.72,1.83s-6.63-1.72-9.95,0.69c-3.32,2.4-10.52,4.57-18.76,5.6
              c-8.23,1.03-28.59,2.4-38.2,3.77c-9.61,1.37-11.89,9.95-12.12,15.44c-0.23,5.49,1.49,29.97-0.23,37.29
              c-1.72,7.32-8.46,14.18-11.67,17.5c-3.2,3.32-8.35,6.29-8.35,6.29s6.4,6.63,19.56,6.18c13.15-0.46,20.59,1.72,28.19-1.43
              s10.35-7.95,10.35-7.95s-0.69,4.06,0.17,4.23c0.86,0.17,7.81-3.23,11.41-5.98c3.6-2.74,5.58-5.15,5.58-5.15s-0.43,4.2-3.09,6.35
              c-2.66,2.14-7.12,4.72-4.72,5.23c2.4,0.51,16.81-1.03,19.82-5.58c3-4.55,4.37-6.18,4.37-6.18s-0.51,5.66-3.35,9.01
              c-2.83,3.35-9.18,6-23.42,7.81s-15.53,3.86-19.39,5.32c-3.86,1.46-23.42,4.49-35.77,3.35c-12.35-1.14-21.85-5.6-26.42,0.57
              c-4.57,6.18-6.06,17.38-3.2,22.99c2.86,5.6,2.86,15.44,11.89,12.92c9.04-2.52,16.81-9.04,28.14-9.49c11.32-0.46,21.16,4,29.05,5.83
              s24.88,2.77,27.45,0.37c2.57-2.4,0.86-5.23-2.14-7.21c-3-1.97-3.35-4.63-3.35-4.63s1.2,1.54,3.77,3.26
              c2.57,1.72,5.06,3.95,6.39,4.72c0.61,0.36,4.59,0.6,5.53-1.97c0.94-2.57,2.23-5.4,2.23-5.4s1.97,3.35,0.69,5.66
              c-1.29,2.32,1.63,2.83,4.03,1.63s7.98-4.98,10.47-5.23c2.49-0.26,4.29,0.51,4.29,0.51s-5.83,0.34-9.44,4.55s-8.92,6.09-17.16,7.38
              c-8.23,1.29-30.54,1.89-40.23,1.46c-9.69-0.43-19.47,0.34-25.48,4.46c-6,4.12-9.69,9.18-9.69,9.18s10.04,2.32,12.61,15.18
              c2.57,12.87-12.87,37.48-12.87,37.48s-5.66,11.24-30.71,16.9S206.78,511.79,206.78,511.79z"
            />
            <path
              d="M419.57,276.46c0,0-114.15,0.46-118.03,0c-3.89-0.46-10.75,0.46-8.46-8.69c2.29-9.15,7.55-18.07,16.47-18.99
              c8.92-0.91,8.92-0.91,8.92-0.91s-2.52-6.4,7.09-10.98s25.85-2.74,25.85-2.74s1.37-5.26,14.18-6.63
              c12.81-1.37,26.31,3.89,30.19,10.52c3.89,6.63,2.52,13.95,2.52,13.95s13.72-4.11,23.33,6.18c9.61,10.29,5.49,18.5,5.49,18.5
              L419.57,276.46z"
            />
            <path
              d="M403.72,359.69c0,0-72.23,0.29-74.69,0c-2.46-0.29-6.8,0.29-5.36-5.5c1.45-5.79,4.78-11.43,10.42-12.01
              s5.65-0.58,5.65-0.58s-1.59-4.05,4.49-6.95c6.08-2.89,16.36-1.74,16.36-1.74s0.87-3.33,8.97-4.2s16.65,2.46,19.11,6.66
              c2.46,4.2,1.59,8.82,1.59,8.82s8.68-2.6,14.76,3.91c6.08,6.51,3.47,11.71,3.47,11.71L403.72,359.69z"
            />
            <path
              d="M410.79,404.43c0,0-56.25,0.23-58.17,0c-1.92-0.23-5.3,0.23-4.17-4.28c1.13-4.51,3.72-8.91,8.12-9.36
              c4.4-0.45,4.4-0.45,4.4-0.45s-1.24-3.16,3.49-5.41c4.73-2.25,12.74-1.35,12.74-1.35s0.68-2.59,6.99-3.27
              c6.31-0.68,12.96,1.92,14.88,5.19s1.24,6.87,1.24,6.87s6.76-2.03,11.5,3.05c4.73,5.07,2.71,9.12,2.71,9.12L410.79,404.43z"
            />
            <path
              d="M165.09,281.75c0,0,56.25,0.23,58.17,0s5.3,0.23,4.17-4.28c-1.13-4.51-3.72-8.91-8.12-9.36
              c-4.4-0.45-4.4-0.45-4.4-0.45s1.24-3.16-3.49-5.41c-4.73-2.25-12.74-1.35-12.74-1.35s-0.68-2.59-6.99-3.27
              c-6.31-0.68-12.96,1.92-14.88,5.19c-1.92,3.27-1.24,6.87-1.24,6.87s-6.76-2.03-11.5,3.05s-2.71,9.12-2.71,9.12L165.09,281.75z"
            />
            <path
              d="M127.28,340.6c0,0,76.67,0.31,79.28,0c2.61-0.31,7.22,0.31,5.68-5.84c-1.54-6.15-5.07-12.14-11.06-12.75
              c-5.99-0.61-5.99-0.61-5.99-0.61s1.69-4.3-4.76-7.37s-17.36-1.84-17.36-1.84s-0.92-3.53-9.53-4.46s-17.67,2.61-20.28,7.07
              s-1.69,9.37-1.69,9.37s-9.22-2.76-15.67,4.15s-3.69,12.43-3.69,12.43L127.28,340.6z"
            />
          </g>

          <g id="lake">
            <path
              d="M1013.95,895.7L1013.95,895.7c0.48-0.12,0.97-0.14,1.45-0.04c4.78,0.95,31.6,6.46,43.83,12.9
              c13.45,7.09,54.13,17.65,82.21,17.65s178.72-17.87,223.66-20.94c44.94-3.06,307.4,4.09,407.49,34.72
              c91.77,28.09,167.28,55.54,179.4,63.15c36.09,22.64,48.44,62.45,48.51,63.66l-33.55,54.09c0.1,1.87-1.38,3.45-3.26,3.47
              l-1205.24,9.17c0,0-553.53,16.34-535.15-40.34c18.38-56.68,519.83-131.23,614.04-126.64c94.21,4.6,184.6,3.06,193.02-13.02
              c7.39-14.11,0.79-40.72-17.28-51.82C1010.6,900.18,1011.11,896.43,1013.95,895.7z"
            />
          </g>
        </g>
      </svg>
      <div id="art-overlay" />

      <div className="interaction">
        <div className="text">
          An old silent pond...
          <br />
          A frog jumps into the pond,
          <br />
          Splash! Silence again.
        </div>
        <button onClick={changeMode}>Change daytime</button>
      </div>
    </div>
  );
};

export default App;
